import { Flex } from '@chakra-ui/react';
import { ColDef } from 'ag-grid-community';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { AccessControlCheckbox } from '../../components/cellComponents/AccessControlCheckbox';
import { MultiValueSelect } from '../../components/cellComponents/MultiValueSelect';
import { SingleValueSelect } from '../../components/cellComponents/SingleValueSelect';
import { CREATE_TABLE_ROLES } from '../roles';

type ColDefs = Array<ColDef>;

export const createTableColDefs: ColDefs = [
  {
    headerName: 'Name',
    field: 'name',
    width: 200,
    editable: false,
    sortable: true,
    cellRenderer: (params) => (
      <Flex alignItems="center" w="100%" h="100%" justifyContent="flex-start">
        <TextBodyMedium>{params.value}</TextBodyMedium>
      </Flex>
    ),
    valueGetter: (params) => params.data.name,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: CREATE_TABLE_ROLES.map((role) => role.name),
      suppressSorting: true,
    },
  },
  {
    headerName: 'Create Objective (By level)',
    field: 'createObjective',
    flex: 1,
    cellRenderer: (props) => (
      <Flex alignItems="center" w="100%" h="100%">
        <MultiValueSelect tableType="rolesToCreateConfig" {...props} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
  },
  {
    headerName: 'Create Key result',
    field: 'createKeyResult',
    flex: 1,
    cellRenderer: (props) => (
      <Flex alignItems="center" w="100%" h="100%">
        <SingleValueSelect showDescription tableType="rolesToCreateConfig" {...props} />
      </Flex>
    ),
    suppressHeaderMenuButton: true,
    cellClass: 'objective-kr-cell-ag-grid-wrap',
    autoHeight: true,
    wrapText: true,
  },
  {
    headerName: 'Create Initiatives',
    field: 'createInitiative',
    flex: 1,
    cellRenderer: (props) => (
      <Flex alignItems="center" w="100%" h="100%">
        <AccessControlCheckbox tableType="rolesToCreateConfig" {...props} />{' '}
      </Flex>
    ),
    suppressHeaderMenuButton: true,
  },
];
